import React from 'react';
import { CouponsCodeFilter } from './CouponsCodeFilter';

export function Actions({ filterText, onFilter, onClear, onAddClick }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '.5rem',
      }}
    >
      <CouponsCodeFilter
        filterText={filterText}
        onFilter={onFilter}
        onClear={onClear}
      />
      <button
        type="button"
        className="btn btn-sm"
        style={{
          background: '#01AB7D',
          color: '#FFFF',
          fontWeight: 500,
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
        }}
        onClick={onAddClick}
        aria-label="Novo cupom"
      >
        Novo cupom
        <i
          className="ki ki-plus"
          style={{
            fontSize: '0.98em',
            color: '#FFFF',
            fontWeight: 'lighter',
          }}
        ></i>
      </button>
    </div>
  );
}
